import './biblio.css';
import '../common/tablerixme.css';
import '../references-documentaires/references-documentaires.css';
import '../carousel/carousel.css';
import '../partenaires/partenaires.css';
import '../utils/utils.css';
import '../references-documentaires/references-documentaires.js';

import { getShowAllElement, limitListElements } from '../utils/utils.js';
import {
  manageButton,
  manageSelectionLinkInHeader,
} from '../selection/utils.js';

const selectionButton = document.querySelector('[data-action="selection:add"]');
if (selectionButton) {
  manageButton(selectionButton);
}

manageSelectionLinkInHeader();

const tagsElement = document.querySelector('.biblio-tags');
if (tagsElement) {
  const showAllElement = getShowAllElement(tagsElement);
  limitListElements(tagsElement, 3, showAllElement);
}
